import ShopCategoryResourceModel from '../../generated/types/model/resource/ShopCategoryResourceModel';

export default class ShopCategoryResourceViewModel extends ShopCategoryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
